import request from '@/utils/request';

export async function getCurrent(params) {
  return request('/menus/current', {
    method: 'POST',
    body: {
      ...params,
    },
  });
}

export async function getMenulogs(params) {
  return request('/menulogs', {
    method: 'POST',
    body: {
      ...params,
    },
  });
}

export async function getIcons() {
  return request('/fonticons');
}

export async function getMenus(urlIndex) {
  return request(`/dirs/${urlIndex}/dirs`);
}

export async function getAllMenus() {
  return request('/menus');
}

export async function getSingleMenus(urlIndex) {
  return request(`/dirs/${urlIndex}/menus`);
}

export async function getSonMenus(urlIndex) {
  return request(`/dirs/${urlIndex}/dirmenus`);
}

export async function changeDirs(params, method) {
  return request('/dirs', {
    method,
    body: {
      ...params,
    },
  });
}

export async function changeMenus(params, method) {
  return request('/menus', {
    method,
    body: {
      ...params,
    },
  });
}

export async function addSonMenus(urlIndex, params) {
  return request(`/dirs/${urlIndex}/menus`, {
    method: 'POST',
    body: params,
  });
}

export async function deleteDir(urlIndex) {
  return request(`/dirs/${urlIndex}`, {
    method: 'DELETE',
  });
}

export async function deleteMenu(urlIndex, params) {
  return request(`/dirs/${urlIndex}/menus`, {
    method: 'DELETE',
    body: params,
  });
}

export async function deleteSingleMenu(menuId) {
  return request(`/menus/${menuId}`, {
    method: 'DELETE',
  });
}

// 查询角色拥有的菜单
export async function qryMenuListByRoleId(roleId) {
  return request(`/roles/${roleId}/menus`);
}

// 查询指定目录下的菜单
export async function qryMenuListByDirId(roleId, dirId) {
  return request(`/roles/${roleId}dirs/${dirId}/menus`);
}

// 查询到用户的门户之后,首先加载门户的跟菜单;也可以加载任意目录下挂的菜单
export async function qryMenuListByPartyId(partyId, portalId, roleId) {
  return request(`roles/${roleId}/portals/${portalId}/party/${partyId}/menus`);
}

// 查询user下的菜单
export async function qryMenuListByUser(userId) {
  return request(`/users/${userId}/menus`);
}

// 查询user => portal => party下的菜单
export async function qryMenuListByUserParty(userId, portalId, partyId) {
  return request(`/users/${userId}/portals/${portalId}/party/${partyId}/menus`);
}
